<template>
    <cell
        :background="'bg-white hover:bg-gray-50 dark:bg-gray-700 dark:hover:bg-gray-800'"
        :class="'sticky z-10'"
    >
        <data-column-buttons
            :actions="actions"
            :column="column"
            :delete-modal-content="deleteModalContent"
            :delete-modal-title="deleteModalTitle"
            :tabindex="tabindex"
        >
            <slot :actions="actions" :column="column" :index="tabindex" name="actions"/>
        </data-column-buttons>
    </cell>
</template>

<script>
import DataColumnButtons from '@/Components/Storemanager/DataColumnButtons';
import DataColumnActions from '@/Components/Storemanager/Entities/DataColumnActions';
import Cell from '@/Components/Storemanager/Column/Cell';
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';

export default {
    components: {DataColumnButtons, Cell},

    props: {
        column: {
            type: DataColumn,
            required: true,
        },
        actions: {
            type: DataColumnActions,
            required: true,
        },
        deleteModalTitle: String,
        deleteModalContent: String,
        tabindex: {
            type: Number,
            default: 0,
        },
    },
};
</script>
